// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbarStyles_toolbar__2tzvK"};